<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { DnDProvider } from "@vue-dnd-kit/core"

defineOptions({
    name: "HomeWorkspaceDnDProvider",
})
</script>

<template>
    <DnDProvider preview-to="body" :auto-scroll-viewport="true">
        <template #preview>
            <HomeWorkspaceDragPreview />
        </template>
        <slot />
    </DnDProvider>
</template>
